// import './index.scss'
import APIS from '../../module/apis'

import { axios as $http, setHeader } from 'cm'

import Hls from 'hls.js'

// import './lib/index'
// import player from './player';

/**
 *
 * @param el [element]
 */
function playInit(el) {
  let { thirdPlayer: playData } = window.baseInfo
  let { cover, url: src } = playData
  if (src && src.length) {
    // x5-video-player-type="h5"
    // x5-video-player-fullscreen="true"
    el.innerHTML = `<video id='video' src="${src}" controls="true"  class="video-player" preload="auto"
                    playsinline
                    webkit-playsinline
                    x5-playsinline="true"
                    x5-playsinline="true"
                    x-webkit-airplay="allow"
                    x5-video-orientation="landscape|portrait"
                    controlslist="nodownload"
                    style="width:100%;max-width: 100%;height: auto;object-fit: fill;"
                    >
                    </video>`
    let video = el.querySelector('video')
    video.setAttribute('poster', cover)
    if (Hls.isSupported()) {
      var hls = new Hls()
      hls.loadSource(src)
      hls.attachMedia(video)
      hls.on(Hls.Events.MANIFEST_PARSED, function() {
        video.play()
      })
    } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
      video.src = src
      video.addEventListener('loadedmetadata', function() {
        video.play()
      })
    }

    video.addEventListener('webkitendfullscreen', () => {
      console.log('webkitendfullscreen')
      setTimeout(() => {
        video.play()
      }, 500)
    })

    video.addEventListener('webkitfullscreenchange', () => {
      console.log('webkitfullscreenchange')
      setTimeout(() => {
        video.play()
      }, 500)
    })

    video.addEventListener('fullscreenchange', () => {
      console.log('fullscreenchange')
      setTimeout(() => {
        video.play()
      }, 500)
    })

    video.addEventListener('x5videoexitfullscreen', function() {
      console.log('x5videoexitfullscreen')
      setTimeout(() => {
        video.play()
      }, 500)
    })

    // 如果是微信,仅限ios生效
    if (window.$platform.isWechat) {
      wx.ready(function() {
        document.getElementById('video').play()
      })
    }
  } else {
    // 无url时只渲染封面
    let playWrap = document.querySelector('#video-player-container')
    playWrap.style.backgroundImage = `url(${cover})`
    playWrap.classList.add('disable-live')
  }
}

export default playInit



// WEBPACK FOOTER //
// ./src/pages/lesson/play/components/player/old_play.js